import y from "./ghl-ui.es1504.js";
import w from "./ghl-ui.es1505.js";
import u from "./ghl-ui.es1501.js";
import d from "./ghl-ui.es1502.js";
import h from "./ghl-ui.es1503.js";
import c from "./ghl-ui.es1506.js";
import { Parser as v } from "./ghl-ui.es1574.js";
import { mapValue as l, parseNDigits as x } from "./ghl-ui.es1575.js";
import b from "./ghl-ui.es1579.js";
var N = /* @__PURE__ */ function(m) {
  d(a, m);
  var n = h(a);
  function a() {
    var o;
    y(this, a);
    for (var r = arguments.length, t = new Array(r), e = 0; e < r; e++)
      t[e] = arguments[e];
    return o = n.call.apply(n, [this].concat(t)), c(u(o), "priority", 90), c(u(o), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), o;
  }
  return w(a, [{
    key: "parse",
    value: function(r, t, e, i) {
      var s = function(f) {
        var p = Math.floor((f - 1) / 7) * 7;
        return (f + i.weekStartsOn + 6) % 7 + p;
      };
      switch (t) {
        case "e":
        case "ee":
          return l(x(t.length, r), s);
        case "eo":
          return l(e.ordinalNumber(r, {
            unit: "day"
          }), s);
        case "eee":
          return e.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || e.day(r, {
            width: "short",
            context: "formatting"
          }) || e.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return e.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return e.day(r, {
            width: "short",
            context: "formatting"
          }) || e.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return e.day(r, {
            width: "wide",
            context: "formatting"
          }) || e.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || e.day(r, {
            width: "short",
            context: "formatting"
          }) || e.day(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, t) {
      return t >= 0 && t <= 6;
    }
  }, {
    key: "set",
    value: function(r, t, e, i) {
      return r = b(r, e, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), a;
}(v);
export {
  N as LocalDayParser
};
